import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-carousel-item',
  templateUrl: './carousel-item.component.html',
  styleUrls: ['./carousel-item.component.css']
})
export class CarouselItemComponent implements OnInit {

  @Input()
  outerImage: string;

  @Input()
  innerImage: string;

  @Input()
  innerText: string;

  constructor() { }

  ngOnInit() {
  }

}
